import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

import Login from "~/login/login";
import Forget from "~/login/forget";
import PersonalCenter from "~/personalCenter/personalCenter";
import PersonalInfo from "~/personalCenter/personalInfo";
import Account from "~/account/account";
import BindPhone from "~/personalCenter/bindPhone";
import Setpassword from "~/personalCenter/setPassword";
import PersonnelManagement from "~/personnelManagement/personnelManagement"; //人员管理
import personnelManagementChecked from "~/personnelManagement/personnelManagementChecked"; //人员管理(选中)
import SympathyManagement from "~/condole/assembly/personnelManagement";

import PersinnelDetail from "~/personnelManagement/persinnelDetail";

import ActivityList from "~/activity/activityList";
import ActivityType from "~/activity/activityType";
import DirectActivity from "~/activity/directActivity";
import SignupActivity from "~/activity/signupActivity";
import RegistrationInfo from "~/activity/registrationInfo";
import SignDistribution from "../view/activity/signDistrubution";

import Home from "~/home/home";
import Welfare from "~/home/welfare";
import WelfareNew from "~/home/welfareNew";
import WelfareDetail from "~/home/welfareDetail";
import ActivityDetail from "~/home/activityDetail";
import Activity from "~/home/activity";
import New from "~/home/new";

//生日慰问
import BirthdayWel from "~/birthdayGreetings/birthdayWel";  //生日慰问首页
import GreetingsDetail from "~/birthdayGreetings/greetingsDetail";  //生日慰问详情
import Greetings from "~/birthdayGreetings/greetings";


// 首页模块
import HomeZhyf from "~/home/homeZhyf";
const GhService = () => import('~/home/ghService'); //工会服务
const ServiceHall = () => import('~/home/serviceHall'); //服务大厅
const ServiceHallEdit = () => import('~/home/serviceHallEdit'); //服务大厅可编辑

// 公共组件模块
const pageNone = () => import('../components/pageNone');

// 慰问模块
import CondoleList from "~/condole/condoleList";
import CondoleApply from "~/condole/condoleApply";
import myCondole from "~/condole/myCondole";
import approvalDemocratic from "~/democratic/approval/approval";

//慰问新模块
import hospitalization from "~/condole/hospitalization/index"; //住院慰问
import hospitalizationApply from "~/condole/hospitalization/apply"; //住院慰问申请
import hospitalizationRule from "~/condole/assembly/Rule"; //住院制度

import death from "~/condole/death/index"; //亲属去世
import deathApply from "~/condole/death/apply"; //亲属去世申请

import rescue from "~/condole/rescue/index"; //大病救助
import rescueApply from "~/condole/rescue/apply"; //大病救助申请

import sympathy from "~/condole/sympathy/index"; //其他慰问
import sympathyApply from "~/condole/sympathy/apply"; //其他慰问申请

import subsidy from "~/condole/subsidy/index"; //困难补助
import subsidyApply from "~/condole/subsidy/apply"; //困难补助申请

import detailsOfSympathy from "~/condole/assembly/detailsOfSympathy";

import shoppingMall from "~/shopping/index"; //普惠商城

// 积分模块
import IntegralDetail from "~/integral/IntegralDetail"; //积分明细
import IntegralSystem from "~/integral/IntegralSystem"; //积分制度

// 步数模块
import StepCount from "~/stepCount/StepCount"; //个人步数统计
import StepRank from "~/stepCount/StepRank"; //步数全部排名
import SportCount from "~/stepCount/SportCount"; //个人运动统计
import GainSteps from "~/stepCount/GainSteps"; //获取积分步数

//我的审批
import approval from "~/approval/index"; //我的审批

//问卷模块
import QuestionList from "~/question/QuestionList";
import ReplyQuestion from "~/question/ReplyQuestion";

import Signature from "../components/signature";

//民主
import workers from "~/democratic/workers/index"; //职工代表大会
import member from "~/democratic/member/index"; //会员代表大会
import proposal from "~/democratic/proposal/index"; //提案征集
import choseDept from "~/democratic/approval/chooseDept"; //提案征集(选择科室)

import suggestDetails from "~/democratic/currency/suggestDetails"; //征集意见
import voteDetails from "~/democratic/currency/voteDetails"; //表决
import solicitingProposals from "~/democratic/currency/solicitingProposals"; //咨询
import personnel from "~/democratic/currency/personnel"; //人员组件
import secondedDetails from "~/democratic/currency/secondedDetails"; //咨询
import secondedDetailsRule from "~/democratic/currency/Rule"; //咨询

// 线上活动--详情
import OnLineActivity from "~/activity/onLineActivity";
// 反馈提交
import FeedSubmit from "~/activity/feedSubmit";

// 普惠商城
import MallHomepage from "~/welfareMall/mallHomepage"; //商城首页
import RecordList from "~/welfareMall/recordList"; //兑换记录
import GoodsDetail from "~/welfareMall/goodsDetail"; //商品详情
import OrderConfrim from "~/welfareMall/orderConfrim"; //订单确认
import OrderConfrimSuccess from "~/welfareMall/orderConfrimSuccess"; //订单确认
import ExchangeDetail from "~/welfareMall/exchangeDetail"; //兑换详情
import AddressList from "~/welfareMall/addressList"; //地址管理
import AddressNew from "~/welfareMall/addressNew"; //地址新增

// 资讯管理
import consultList from "~/consultManage/consultList"; //资讯列表
import consultDetail from "~/consultManage/consultDetail"; //资讯详情
//通知公告
import noticeList from "~/noticeManage/noticeList"; //通知公告
import noticeDetail from "~/noticeManage/noticeDetail"; //通知详情

import autograp from "~/autograp/autograp";

export default new Router({
  mode: "history",
  routes: [
   
    {
      path: "/pageNone",
      name: "pageNone",
      meta: {
        title: ""
      },
      component: pageNone
    },
    {
      path: "/serviceHall",
      name: "serviceHall",
      meta: {
        title: "服务大厅"
      },
      component: ServiceHall
    },
    {
      path: "/serviceHallEdit",
      name: "serviceHallEdit",
      meta: {
        title: "服务大厅"
      },
      component: ServiceHallEdit
    },
    {
      path: "/ghService",
      name: "ghService",
      meta: {
        title: "工会服务"
      },
      component: GhService
    },
    {
      path: "/signature",
      name: "signature",
      meta: {
        title: "签名"
      },
      component: Signature
    },
    {
      path: "/login",
      name: "login",
      meta: {
        title: "登录"
      },
      component: Login
    },
    {
      // 积分明细
      path: "/integralDetail",
      name: "IntegralDetail",
      meta: {
        title: "积分明细"
      },
      component: IntegralDetail
    },
    {
      // 积分制度
      path: "/integralSystem",
      name: "IntegralSystem",
      meta: {
        title: "积分制度"
      },
      component: IntegralSystem
    },
    {
      // 个人步数统计
      path: "/stepCount",
      name: "StepCount",
      meta: {
        title: "个人步数统计"
      },
      component: StepCount
    },
    {
      // 个人运动统计
      path: "/sportCount",
      name: "SportCount",
      meta: {
        title: "个人运动统计"
      },
      component: SportCount
    },
    {
      // 获取积分步数
      path: "/gainSteps",
      name: "gainSteps",
      meta: {
        title: "微信步数",
        requireAuth: true
      },
      component: GainSteps
    },
    {
      // 全部排名
      path: "/stepRank",
      name: "StepRank",
      meta: {
        title: "全部排名"
      },
      component: StepRank
    },

    {
      path: "/forget",
      name: "forget",
      meta: {
        title: "忘记密码"
      },
      component: Forget
    },
    {
      path: "/approvalDemocratic",
      name: "approvalDemocratic",
      component: approvalDemocratic,
      meta: {
        title: "提案审批",
        keepAlive: true
      }
    },
    {
      path: "/personalCenter",
      name: "personalCenter",
      component: PersonalCenter,
      meta: {
        title: "个人中心",
        requireAuth:true,
      }
    },
    {
      path: "/secondedDetails",
      name: "secondedDetails",
      component: secondedDetails,
      meta: {
        title: "附议详情"
      }
    },
    {
      path: "/personalInfo",
      name: "personalInfo",
      component: PersonalInfo,
      meta: {
        title: "个人信息"
      }
    },
    {
      path: "/personnel",
      name: "personnel",
      component: personnel,
      meta: {
        title: "人员信息"
      }
    },
    {
      path: "/solicitingProposals",
      name: "solicitingProposals",
      component: solicitingProposals,
      meta: {
        title: "征集意见"
      }
    },
    {
      path: "/suggestDetails",
      name: "suggestDetails",
      component: suggestDetails,
      meta: {
        title: "征集意见详情"
      }
    },
    {
      path: "/secondedDetailsRule",
      name: "secondedDetailsRule",
      component: secondedDetailsRule,
      meta: {
        title: "制度"
      }
    },
    {
      path: "/voteDetails",
      name: "voteDetails",
      component: voteDetails,
      meta: {
        title: "表决详情"
      }
    },
    {
      path: "/account",
      name: "account",
      component: Account,
      meta: {
        title: "账户管理",
        requireAuth:true,
      }
    },
    {
      path: "/workers",
      name: "workers",
      component: workers,
      meta: {
        title: "职工代表大会"
      }
    },
    {
      path: "/member",
      name: "member",
      component: member,
      meta: {
        title: "会员代表大会"
      }
    },
    {
      path: "/proposal",
      name: "proposal",
      component: proposal,
      meta: {
        title: "提案征集"
      }
    },
    {
      path: "/choseDept",
      name: "choseDept",
      component: choseDept,
      meta: {
        title: "选择科室"
      }
    },
    {
      path: "/bindPhone",
      name: "bindPhone",
      component: BindPhone,
      meta: {
        title: "绑定手机"
      }
    },
    {
      path: "/setPassword",
      name: "setPassword",
      component: Setpassword,
      meta: {
        title: "设置密码"
      }
    },
    {
      // path: "/home",
      // name: "home",
      path: "/homeZhyf",
      name: "homeZhyf",
      component: HomeZhyf,
      meta: {
        keepAlive: true,
        requireAuth:true,
        title: ""
      },
      children: [
        // {
        //   path: "/homeZhyf",
        //   name: "homeZhyf",
        //   component:HomeZhyf,
        //   meta: {
        //     title: "智慧云服"
        //   }
        // },
        {
          path: "/new",
          name: "new",
          component: New,
          meta: {
            title: "天坛工会管理系统"
          }
        }
      ]
    },
    {
      path: "/sympathyManagement",
      name: "sympathyManagement",
      component: SympathyManagement,
      meta: {
        title: "人员选择"
      }
    },
    {
      path: "/personnelManagement",
      name: "personnelManagement",
      component: PersonnelManagement,
      meta: {
        title: "职工选择"
      }
    },
    {
      path: "/personnelManagementChecked",
      name: "personnelManagementChecked",
      component: personnelManagementChecked,
      meta: {
        title: "职工选择"
      }
    },

    {
      path: "/detailsOfSympathy",
      name: "detailsOfSympathy",
      component: detailsOfSympathy,
      meta: {
        title: "详情"
      }
    },
    {
      path: "/activity",
      name: "activity",
      component: Activity,
      meta: {
        title: "我的活动",
        keepAlive: true
      }
    },
    {
      path: "/welfare",
      name: "welfare",
      component: Welfare,
      meta: {
        title: "我的节日慰问"
      }
    },
    {
      path: "/welfareNew",
      name: "welfareNew",
      component: WelfareNew,
      meta: {
        title: "我的节日慰问",
        keepAlive: true
      }
    },
    {
      path: "/birthdayWel",
      name: "birthdayWel",
      meta: {
        title: "我的生日慰问",
        keepAlive: true
      },
      component: BirthdayWel
    },
    {
      path: "/greetingsDetail",
      name: "greetingsDetail",
      meta: {
        title: "生日慰问详情",
      },
      component: GreetingsDetail
    },
    {
      path: "/greetings",
      name: "greetings",
      component: Greetings,
      meta: {
        title: "我的生日慰问"
      }
    },
   
    // {
    //   path: "/shoppingMall",
    //   name: "shoppingMall",
    //   component: shoppingMall,
    //   meta: {
    //     title: "普惠商城"
    //   }
    // },
    {
      path: "/persinnelDetail",
      name: "persinnelDetail",
      component: PersinnelDetail,
      meta: {
        title: "会员详情"
      }
    },
    {
      path: "/welfareDetail",
      name: "welfareDetail",
      component: WelfareDetail,
      meta: {
        title: "节日慰问详情"
      }
    },
    {
      path: "/activityDetail",
      name: "activityDetail",
      component: ActivityDetail,
      meta: {
        title: "活动奖品签名",
      }
    },
    {
      path: "/activityList",
      name: "activityList",
      component: ActivityList,
      meta: {
        title: "活动列表",
      }
    },
    {
      path: "/activityType",
      name: "activityType",
      component: ActivityType,
      meta: {
        title: "活动类型选择"
      }
    },
    {
      path: "/signDistribution",
      name: "signDistribution",
      component: SignDistribution,
      meta: {
        title: "报名分配"
      }
    },
    {
      path: "/onLineActivity",
      name: "onLineActivity",
      component: OnLineActivity,
      meta: {
        title: "线上活动"
      }
    },
    {
      path: "/feedSubmit",
      name: "FeedSubmit",
      component: FeedSubmit,
      meta: {
        title: "反馈提交"
      }
    },
    {
      path: "/directActivity",
      name: "directActivity",
      component: DirectActivity,
      meta: {
        title: "打卡活动"
      }
    },
    {
      path: "/signupActivity",
      name: "signupActivity",
      component: SignupActivity,
      meta: {
        title: "报名活动",
        keepAlive: false
      }
    },
    {
      path: "/member",
      name: "member",
      component: member,
      meta: {
        title: "会员代表大会"
      }
    },

    {
      path: "/workers",
      name: "workers",
      component: workers,
      meta: {
        title: "职工代表大会"
      }
    },

    {
      path: "/proposal",
      name: "proposal",
      component: proposal,
      meta: {
        title: "提案征集"
      }
    },
    {
      path: "/registrationInfo",
      name: "registrationInfo",
      component: RegistrationInfo,
      meta: {
        title: "活动管理"
      }
    },
    {
      path: "/condoleList",
      name: "CondoleList",
      component: CondoleList,
      meta: {
        title: "慰问管理"
      }
    },
    {
      path: "/condoleApply",
      name: "CondoleApply",
      component: CondoleApply,
      meta: {
        title: "慰问申请"
      }
    },
    {
      path: "/myCondole",
      name: "myCondole",
      component: myCondole,
      meta: {
        title: "我的慰问"
      }
    },
    {
      path: "/questionList",
      name: "QuestionList",
      component: QuestionList,
      meta: {
        title: "我的问卷"
      }
    },
    {
      path: "/replyQuestion",
      name: "ReplyQuestion",
      component: ReplyQuestion,
      meta: {
        title: "问卷答题"
      }
    },
    {
      path: "/approval",
      name: "approval",
      component: approval,
      meta: {
        title: "我的审批",
        keepAlive:false
      }
    },
    {
      path: "/hospitalization",
      name: "hospitalization",
      component: hospitalization,
      meta: {
        title: "住院慰问"
      }
    },
    {
      path: "/hospitalizationApply",
      name: "hospitalizationApply",
      component: hospitalizationApply,
      meta: {
        title: "住院慰问申请"
      }
    },
    {
      path: "/hospitalizationRule",
      name: "hospitalizationRule",
      component: hospitalizationRule,
      meta: {
        title: "大病救助制度"
      }
    },
    {
      path: "/death",
      name: "death",
      component: death,
      meta: {
        title: "亲属去世"
      }
    },
    {
      path: "/deathApply",
      name: "deathApply",
      component: deathApply,
      meta: {
        title: "亲属去世申请"
      }
    },
    {
      path: "/rescue",
      name: "rescue",
      component: rescue,
      meta: {
        title: "大病救助"
      }
    },
    {
      path: "/rescueApply",
      name: "rescueApply",
      component: rescueApply,
      meta: {
        title: "大病救助申请"
      }
    },
    {
      path: "/sympathy",
      name: "sympathy",
      component: sympathy,
      meta: {
        title: "其他慰问"
      }
    },
    {
      path: "/sympathyApply",
      name: "sympathyApply",
      component: sympathyApply,
      meta: {
        title: "其他慰问申请"
      }
    },
    {
      path: "/subsidy",
      name: "subsidy",
      component: subsidy,
      meta: {
        title: "困难补助"
      }
    },
    {
      path: "/subsidyApply",
      name: "subsidyApply",
      component: subsidyApply,
      meta: {
        title: "困难补助申请"
      }
    },
    {
      path: "/shoppingMall",
      name: "shoppingMall",
      component: MallHomepage,
      meta: {
        title: "自选慰问"
      }
    },
    {
      path: "/recordList",
      name: "recordList",
      component: RecordList,
      meta: {
        title: "兑换记录"
      }
    },
    {
      path: "/goodsDetail",
      name: "goodsDetail",
      component: GoodsDetail,
      meta: {
        title: "商品详情"
      }
    },
    {
      path: "/orderConfrim",
      name: "orderConfrim",
      component: OrderConfrim,
      meta: {
        title: "订单确认",
        keepAlive: true
      }
    },
    {
      path: "/orderConfrimSuccess",
      name: "orderConfrimSuccess",
      component: OrderConfrimSuccess,
      meta: {
        title: "订单确认"
      }
    },
    {
      path: "/exchangeDetail",
      name: "exchangeDetail",
      component: ExchangeDetail,
      meta: {
        title: "兑换详情"
      }
    },
    {
      path: "/addressList",
      name: "addressList",
      component: AddressList,
      meta: {
        title: "配送地址"
      }
    },
    {
      path: "/addressNew",
      name: "addressNew",
      component: AddressNew,
      meta: {
        title: "新增配送地址"
      }
    },
    {
      path: "/consultList",
      name: "consultList",
      component: consultList,
      meta: {
        title: "新闻资讯"
      }
    },
    {
      path: "/consultDetail",
      name: "consultDetail",
      component: consultDetail,
      meta: {
        title: "新闻资讯"
      }
    },
    {

      path: "/noticeList",
      name: "noticeList",
      component: noticeList,
      meta: {
        title: "公告通知"
      }
    },
    {
      path: "/noticeDetail",
      name: "noticeDetail",
      component: noticeDetail,
      meta: {
        title: "通知详情"
      }
    },
    {
      path: "/autograp",
      name: "autograp",
      component: autograp,
      meta: {
        title: "签名",
      },
    }
  ]
});
